import React, { useCallback, useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import { getUserId, getEventId } from "../../services/helper"
import ROUTES from "../../services/routes"
import { setLoading } from "../../redux/loading"
import useHistoryCustom from "../../hooks/useHistoryCustom"
import { IUserCustom } from "../../interfaces/user.custom"
import EmployeeApi from "../../services/api/Employee.api"
import UsersTable from "./users.registered.table"

const UsersRegistered = () => {
  const history = useHistoryCustom()
  const dispatch = useDispatch()
  const [users, setUsers] = useState<IUserCustom[]>([])

  const fetchUsers = useCallback(async () => {
    dispatch(setLoading(true))
    setUsers(
      await new EmployeeApi(getEventId()).getAssociatesWithParticipation(
        getUserId()
      )
    )
    dispatch(setLoading(false))
  }, [dispatch])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])

  const me = users.filter(u => u.userId === getUserId() && u.registered)
  const others = users.filter(u => u.userId !== getUserId() && u.registered)

  return (
    <div>
      <div>
        <div
          className="is-size-4 has-text-weight-semibold has-text-black"
          style={{ margin: "10px 0" }}
        >
          Mon inscription
        </div>
        {me.length ? (
          <UsersTable users={me} />
        ) : (
          <div>
            <div> Vous n'êtes pas inscrit à l'événement.</div>
            <button
              type="button"
              className="button is-primary"
              style={{ marginTop: 10 }}
              onClick={() =>
                history.push(ROUTES.EVENTS_INSCRIPTION, {
                  userId: getUserId()
                })
              }
            >
              Je veux m'inscrire
            </button>
          </div>
        )}
      </div>
      <div>
        <div
          className="is-size-4 has-text-weight-semibold has-text-black"
          style={{ margin: "10px 0" }}
        >
          Autres personnes inscrites ({others.length} pers)
        </div>
        <button
          type="button"
          className="button is-primary"
          style={{ marginBottom: 10 }}
          onClick={() => history.push(ROUTES.EVENTS_INSCRIPTION)}
        >
          Inscrire une nouvelle personne
        </button>
        {others.length ? (
          <UsersTable users={others} />
        ) : (
          <div>Aucune personnes ne sont inscrites à cet événement</div>
        )}
      </div>
    </div>
  )
}

export default UsersRegistered
